/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  env: 'staging',
  production: true,
  backend: 'https://app-staging.storydoc.com/api',
  stories: 'https://www-staging.storydoc.com',
  storiesOld: 'https://www-staging.storydoc.com',
  assets: 'https://assets-staging.storydoc.com',
  mixpanel: '97d8ed158b18e01de0155b8eb903b7f3',
  blankTemplateId: '617fdf56541e2859725b4f0c',
  sealComponentId: '62fdfc7b180985cb170b92c8',
  latestStoriesOrgId: '1ec550de0cfcfc61503d746d13a28083',
  files: 'storydoc-files-staging',
  oktaAppId: '0oa4hp85crSg96e4I5d6',
  paddle: {
    vendorId: 2373,
    designerAdviceProductId: 12537,
    additionalSeatsSubsId: 35915,
    plans: [{
      period: 'Monthly',
      title: 'Pro',
      price: 60,
      id: '12528',
      seats: 1,
      seatPrice: 60
    }, {
      period: 'Annually',
      title: 'Pro',
      price: 540,
      id: '13311',
      seats: 1,
      seatPrice: 540
    }, {
      period: 'Monthly',
      title: 'Starter',
      price: 50,
      id: '12527',
      seats: 1,
      seatPrice: 50,
      legacy: true
    }, {
      period: 'Annually',
      title: 'Starter',
      price: 480,
      id: '13310',
      seats: 1,
      seatPrice: 480,
      legacy: true
    }, {
      period: 'Monthly',
      title: 'Starter',
      price: 40,
      id: '39729',
      seats: 1,
      seatPrice: 40
    }, {
      period: 'Annually',
      title: 'Starter',
      price: 360,
      id: '39730',
      seats: 1,
      seatPrice: 360
    }, {
      period: 'Monthly',
      title: 'Premium',
      price: 500,
      id: '13313',
      seats: 15,
      seatPrice: 500
    }, {
      period: 'Annually',
      title: 'Premium',
      price: 4800,
      id: '13314',
      seats: 15,
      seatPrice: 4800
    }]
  },
  appSumo: {
    plans: [
      {
        period: 'Lifetime',
        title: 'AppSumo License Tier 1 Lifetime plan',
        price: 69,
        id: 'storydoc_tier1',
        seats: 1,
        seatPrice: 40
      },
      {
        period: 'Lifetime',
        title: 'AppSumo License Tier 2 Lifetime plan',
        price: 149,
        id: 'storydoc_tier2',
        seats: 5,
        seatPrice: 40
      },
      {
        period: 'Lifetime',
        title: 'AppSumo License Tier 3 Lifetime plan',
        price: 309,
        id: 'storydoc_tier3',
        seats: 15,
        seatPrice: 40
      }
    ]
  },
  editorUrl: 'https://app-staging.storydoc.com/',
  editorV4Url: 'https://editor-staging.storydoc.com/'
};
